export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-lg">
                51
              </span>
              <span className="font-heading font-bold text-lg">
                每日大赛
              </span>
            </a>
            <p className="text-sm text-background-50/60 leading-relaxed">
              51每日大赛致力于为每日大赛用户提供最新、最全的网站入口、APP下载与赛事资讯导航服务，让每一位用户都能快速直达官方平台，不错过任何精彩内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#cards" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">赛事速递</a>
              <a href="#ranking" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">热度榜单</a>
              <a href="#topics" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">热门话题</a>
              <a href="#faq" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              服务入口
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#app" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">APP下载</a>
              <a href="#contact" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</a>
              <a href="#index" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">主题索引</a>
              <a href="#media" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">媒体中心</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              合作伙伴
            </h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              期待与更多平台携手合作，共建每日大赛生态圈。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 51每日大赛. 本站为每日大赛入口导航站，内容仅供参考。
          </p>
          <p className="text-xs text-background-50/30">
            51每日大赛入口网站 — 每日大赛最新网址大全
          </p>
        </div>
      </div>
    </footer>
  );
}